module.exports = __webpack_public_path__ + "img/img22.9a29419a.svg";